import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import Swal from 'sweetalert2';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'src/app/_services/toastr.service';
import { Router } from '@angular/router';
import { HomeComponent } from '../home.component';
declare var $;

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.css'],
})
export class RoleComponent implements OnInit {
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: true }) table;
  menuDataTable: any;
  menudtOptions: any;
  menuTableData = [];
  @ViewChild('menuDataTable', { static: true }) menuTable;
  @ViewChild('btnClose', { static: true }) btnClose: ElementRef;
  @ViewChild('btnModalOpen', { static: true }) btnModalOpen: ElementRef;
  roleForm: FormGroup;
  roleModel: any;
  menuModel: any;
  indexes = [];
  menuList = [];
  header: string;

  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private appComponent: AppComponent,
    private toastrService: ToastrService,
    private router: Router,
    private homeComponent: HomeComponent
  ) {
    Window['approle'] = this;
  }

  ngOnInit() {
    this.authService.isAuthenticated();
    this.appComponent.setTitle('Role');

    this.authService.pageVisit().subscribe(
      () => {},
      (error) => {
        console.log(error);
      }
    );

    this.getRoleList();
    this.CreateRoleForm();
  }

  SetInactive() {
    this.homeComponent.SetInactive();
  }

  CreateRoleForm() {
    this.header = 'Create Role';
    this.roleForm = this.fb.group({
      Id: ['', Validators.nullValidator],
      RoleName: ['', Validators.required],
      IndexPage: ['', Validators.required],
      MenuPermission: this.fb.array([]),
    });

    this.authService.getMenuList().subscribe(
      (data) => {
        this.indexes = data.index;
        data.menulist.forEach((value, index) => {
          this.MenuPermission.push(
            this.fb.group({
              Index: [index + 1],
              VMenuId: [value.vMenuID],
              NameWithParent: [value.nameWithParent],
              PageUrl: [value.nvPageUrl],
              IsChecked: [false],
            })
          );
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  get MenuPermission(): FormArray {
    return this.roleForm.get('MenuPermission') as FormArray;
  }

  getRoleList() {
    this.authService.getRoleList().subscribe(
      (data) => {
        data.roles.forEach((value, index) => {
          value.index = index + 1;
        });
        this.tableData = data.roles;
        this.dtOptions = {
          data: this.tableData,
          columns: [
            { title: '#', data: 'index' },
            { title: 'Role Name', data: 'name' },
            { title: 'Dashboard', data: 'indexPage' },
            { title: 'No. of Total User', data: 'totalUser' },
            {
              title: 'Action',
              data: 'id',
              sortable: false,
              render: function (data, type, full, meta) {
                const bid = '"' + full.id + '"';
                return (
                  '<div class="text-center fs-18"> ' +
                  '<a title="Edit" class="edit" onclick="Window.approle.edit(' +
                  bid +
                  ')"><i class="far fa-edit" style="cursor: pointer;"> </i> </a> |' +
                  '<a title="Delete" onclick="Window.approle.remove(' +
                  bid +
                  ')"> <i class="fas fa-trash-alt" style="color: red; cursor: pointer;"></i></a>' +
                  '</div>'
                );
              },
            },
          ],
          responsive: true,
          autoWidth: false,
        };
      },
      (err) => {
        console.log(err);
      },
      () => {
        this.dataTable = $(this.table.nativeElement);
        this.dataTable.DataTable(this.dtOptions);
      }
    );
  }

  saveRole() {
    if (this.roleForm.valid) {
      this.roleModel = Object.assign({}, this.roleForm.value);
      this.roleModel.Id = this.roleModel.Id === '' ? null : this.roleModel.Id;
      const role = {
        Id: this.roleModel.Id,
        Name: this.roleModel.RoleName,
        IndexPage: this.roleModel.IndexPage,
      };
      this.roleModel.MenuPermission.forEach((x) => {
        if (x.PageUrl === role.IndexPage) {
          x.IsChecked = true;
        }
      });
      const menuPermission = this.roleModel.MenuPermission.filter(
        (x) => x.IsChecked === true
      );
      const customRole = {
        Role: role,
        MenuPermission: menuPermission,
      };
      this.authService.saveRole(customRole).subscribe(
        () => {
          this.btnClose.nativeElement.click();
          this.toastrService.success('', 'Role save successfully');
          const url = this.router.url;
          this.router
            .navigateByUrl('/SidebarComponent', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([url]);
            });
        },
        (error) => {
          this.toastrService.error('', 'Role save failed');
          console.log(error);
        }
      );
    } else {
      this.appComponent.validateAllFormFields(this.roleForm);
      this.toastrService.warning('', 'Required field is not filled');
    }
  }

  edit(id) {
    this.btnModalOpen.nativeElement.click();
    this.header = 'Update Role';
    this.authService.getRoleById(id).subscribe(
      (data) => {
        const role = data.role[0];
        this.roleForm.controls.Id.setValue(role.id);
        this.roleForm.controls.RoleName.setValue(role.name);
        this.roleForm.controls.IndexPage.setValue(role.indexPage);
        data.menupermission.forEach((value, index) => {
          const temp = this.MenuPermission.controls.find(
            (x) => x.value.VMenuId === value.vMenuId
          );
          this.MenuPermission.controls[temp.value.Index - 1].setValue({
            Index: temp.value.Index,
            VMenuId: temp.value.VMenuId,
            NameWithParent: temp.value.NameWithParent,
            PageUrl: temp.value.PageUrl,
            IsChecked: true,
          });
        });
      },
      (err) => {
        this.btnClose.nativeElement.click();
        this.toastrService.error('', 'Data fetch problem');
        console.log(err);
      }
    );
  }

  remove(data) {
    Swal.fire({
      title: 'Are you sure to delete this?',
      text: 'You won"t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.authService.deleteRole(data).subscribe(
          () => {
            this.toastrService.success('', 'Role delete successfully');
            window.location.reload();
          },
          (error) => {
            this.toastrService.error('', 'Role delete failed');
            console.log(error);
          }
        );
      }
    });
  }

  cancel() {
    this.CreateRoleForm();
  }
}
